// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"skeleton-image_skeletonWrapper__7m2pL"};